import { render, staticRenderFns } from "./OrderStatistics.vue?vue&type=template&id=5444f769&scoped=true"
import script from "./OrderStatistics.vue?vue&type=script&lang=js"
export * from "./OrderStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444f769",
  null
  
)

export default component.exports